export default __webpack_public_path__ + "static/media/slider4.5e03645e.jpg";